import { Injectable } from '@angular/core';
import jwtDecode, { JwtPayload } from 'jwt-decode';

const TOKEN_KEY = 'token-avalservi';
const REFRESH_TOKEN_KEY = 'refresh-token-avalservi';

@Injectable({ providedIn: 'root' })
export class TokenService {
  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }

  isValidToken(): boolean {
    return this.isValidJwt(this.getToken());
  }

  isValidRefreshToken(): boolean {
    return this.isValidJwt(this.getRefreshToken());
  }

  private isValidJwt(token: string | null): boolean {
    if (!token) {
      return false;
    }

    try {
      const decodeToken = jwtDecode<JwtPayload>(token);

      if (!decodeToken?.exp) {
        return false;
      }

      const tokenDate = new Date(0);
      tokenDate.setUTCSeconds(decodeToken.exp);

      return tokenDate.getTime() > Date.now();
    } catch {
      return false;
    }
  }
}
